module.exports = "https://assets.pclncdn.com/web/next-landing/967f96dee0/_next/static/images/hotel-image-2x-fc0bd41826c469f5201dab630a4d3b9b.jpg";